import { render, staticRenderFns } from "./FormEditor.vue?vue&type=template&id=dc9e3474&scoped=true&"
import script from "./FormEditor.vue?vue&type=script&lang=js&"
export * from "./FormEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc9e3474",
  null
  
)

export default component.exports